import { BaseModel } from "../../../core/util/BaseModel";
import { observable, action, makeObservable } from "mobx";
import { IUiAction } from "../../../core/uiAction/IUiAction";
import moment from "moment";

export interface ActivityCardConfig {
  actions?: IUiAction<ActivityCardModel>[];
}

export class ActivityCardModel extends BaseModel {
  @observable inputValue: string = "";
  @observable isEditMode: boolean = false;
  @observable config: ActivityCardConfig = {
    actions: []
  };
  @observable.ref comment: FP.Entities.IComment;
  onSave: ((comment: FP.Entities.IComment) => void) | any;
  removeCommentCollapse: boolean;

  constructor(
    comment: FP.Entities.IComment,
    initOpts?: ActivityCardConfig,
    removeCommentCollapse?: boolean,
    onSave?: ((comment: FP.Entities.IComment) => void) | any
  ) {
    super();
    makeObservable(this);
    this.comment = comment;
    this.inputValue = comment.content;
    this.onSave = onSave;
    this.removeCommentCollapse = removeCommentCollapse;

    if (initOpts) {
      this.setConfig(initOpts);
    }
  }

  @action
  setConfig = (config: Partial<ActivityCardConfig>) => {
    this.config = { ...this.config, ...config };
  };

  @action
  enterEditMode = () => {
    this.isEditMode = true;
  };

  @action
  exitEditMode = () => {
    this.isEditMode = false;
    this.inputValue = this.comment.content;
  };

  @action
  handleInputChange = (value: string) => {
    this.inputValue = value;
  };

  handleOnSave = (comment: FP.Entities.IComment) => {
    const updatedComment: FP.Entities.IComment = {
      ...comment,
      content: this.inputValue,
      updatedAt: moment().toString()
    };

    if (this.onSave && typeof this.onSave === "function") {
      this.onSave(updatedComment);
    }
  };
}
